/**
 * Host-aware UX helpers.
 *
 * Architecture (claude.com pattern, single TLD):
 *   snowmed.health                  — marketing landing (anthropic.com-shaped)
 *   summarisenow.snowmed.health     — doctor product (claude.ai-shaped)
 *   platform.snowmed.health         — developer console (platform.claude.com-shaped)
 *   snowmed.health/download         — desktop download (claude.com/download-shaped)
 *
 * snowmed.io and its subdomains 301 to the .health equivalents (handled at edge).
 */

const DOCTOR_HOSTS    = new Set(["summarisenow.snowmed.health"])
const MARKETING_HOSTS = new Set(["snowmed.health", "www.snowmed.health"])
const PLATFORM_HOSTS  = new Set(["platform.snowmed.health"])

export function getHostname(): string {
  if (typeof window === "undefined") return ""
  return window.location.hostname
}

export function isDoctorHost():    boolean { return DOCTOR_HOSTS.has(getHostname()) }
export function isMarketingHost(): boolean { return MARKETING_HOSTS.has(getHostname()) }
export function isPlatformHost():  boolean {
  // Treat anything not doctor/marketing as platform — covers platform.snowmed.health
  // and any legacy host (app.snowmed.io, platform.snowmed.io) before the 301s land.
  return !isDoctorHost() && !isMarketingHost()
}

/** Brand label shown in nav/login depending on host. */
export function brandLabel(): string {
  if (isDoctorHost()) return "SNOW Web"
  return "SNOW"
}
